module.exports = __webpack_public_path__ + "static/media/card-ayultai.a9673d85.png";